import { Component, OnInit } from '@angular/core';
import { RoutingStateService } from 'src/app/core/services/routing-state/routing-state.service';
import { environment } from 'src/environments/environment';
import { TabService } from 'src/app/tabs/services/tab.service';

@Component({
  selector: 'app-403',
  templateUrl: './403.component.html',
  styleUrls: ['./403.component.scss']
})
export class ForbiddenComponent implements OnInit {

  error:string;

  constructor(private routingStateService: RoutingStateService, private tabService: TabService) { }

  ngOnInit() {
    this.error = localStorage.getItem('error');
    localStorage.removeItem('error');
  }

  goBack(){
    let baseRef = environment.server;
    if (!baseRef.endsWith("/")) {
      baseRef += "/";
    }

    let returnUrl = this.routingStateService.getPreviousUrlBeforeError();

    let index = this.routingStateService.getTabIndex('/error/403');

    if(index)
      this.tabService.removeTab(index);

      window.location.href = baseRef + 'web/#' + returnUrl;

  }

}
